import type { RefundsState } from './types';

export const initialState: RefundsState = {
  apiError: null,
  selectedInstitution: null,
  selectedPatient: null,
  refundDetails: {
    refundId: '',
    eligibleAmount: null,
    prn: '',
    refundsStatus: false,
    billingAccount: '',
  },
  refundSummaryInfo: {
    eligibleAmount: null,
    refundMode: null,
    accountNumber: null,
    accountHolderName: null,
    bankName: null,
    bankCode: null,
    nric: null,
    selectedPrn: null,
  },
  refundSubmitStatus: {
    Status: '',
  },
  refundDraft: null,
  isEditing: false,
};
